export default {
  created() {
    // Обычный computed кэшируется Vue до смены реактивных зависимостей — здесь их нет,
    // поэтому используем нативный JS-геттер: каждое обращение к свойству пересобирает массив.
    Object.defineProperty(this, '$_bidHistoryDateHeaders', {
      get: () => [
        { text: this.$t('Tenders.FilingDate'), value: 'timeSupplyBids', width: '2.5' },
        { text: this.$t('Tenders.CancellationDate'), value: 'timeCancelBid', width: '2.5' }
      ]
    })
  }
}
